import { useState } from 'react'

import { EMPTY_FUNCTION } from '../../../constants/common'
import { Avatar, AVATAR_HEIGHT_24 } from '../../Avatar'
import { ICON_HEIGHT_20, IconNG } from '../../Icon'
import { Status } from '../../Status'
import { Tag, TAG_APPEARANCE, TAG_HEIGHT } from '../../Tag'
import { Component, ComponentProps } from '../Component'
import { Container } from '../Container'
import { boolean, controls, radioGroup, text } from '../Controls'

import EmailIcon from '../../../icons/email.svg'

const APPEARANCE_OPTIONS = Object.values(TAG_APPEARANCE)

const HEIGHT_OPTIONS = Object.values(TAG_HEIGHT)

const beforeMock = (
  <Avatar color='var(--color-chart-1)' size={AVATAR_HEIGHT_24} text='AB' />
)

const metaMock = (
  <Status
    backgroundColor='var(--color-error-10)'
    text='Error'
    textColor='var(--color-error)'
  />
)

const afterMock = <IconNG Icon={EmailIcon} size={ICON_HEIGHT_20} />

function TagAllVariants({
  appearance,
  backgroundColor,
  backgroundColorHover,
  height,
  isDisabled,
  isError,
  isLoading,
  isSkeleton,
  qaName,
  removeTooltipKey,
  secondText,
  text: textValue,
  textColor,
  textColorHover,
  tooltip,
  withAfter,
  withBefore,
  withMeta,
  withOnClick,
  withOnRemove,
  withTooltip,
}) {
  const sharedProps = {
    appearance,
    backgroundColor,
    backgroundColorHover,
    height,
    isDisabled,
    isError,
    isLoading,
    isSkeleton,
    meta: withMeta ? metaMock : null,
    qaName,
    removeTooltipKey,
    textColor,
    textColorHover,
    tooltip,
    withTooltip,
    onClick: withOnClick ? EMPTY_FUNCTION : undefined,
    onRemove: withOnRemove ? EMPTY_FUNCTION : undefined,
  }

  return (
    <Container label='Tag'>
      <Tag
        {...sharedProps}
        afterContent={withAfter ? afterMock : null}
        beforeContent={withBefore ? beforeMock : null}
        secondText={secondText}
        text={textValue}
      />
    </Container>
  )
}

export function TagUsage() {
  const [props, setProps] = useState(() =>
    controls()
      .add(text('text', 'Label'))
      .add(text('secondText'))
      .add(text('tooltip'))
      .add(text('removeTooltipKey'))
      .add(text('qaName'))
      .add(
        radioGroup('appearance', TAG_APPEARANCE.outlined, {
          options: APPEARANCE_OPTIONS,
        })
      )
      .add(
        radioGroup('height', TAG_HEIGHT.height32, {
          options: HEIGHT_OPTIONS,
        })
      )
      .add(boolean('isDisabled'))
      .add(boolean('isError'))
      .add(boolean('isLoading'))
      .add(boolean('isSkeleton'))
      .add(boolean('withTooltip', true))
      .add(boolean('withBefore'))
      .add(boolean('withMeta'))
      .add(boolean('withAfter'))
      .add(boolean('withOnClick'))
      .add(boolean('withOnRemove'))
      .add(text('backgroundColor'))
      .add(text('backgroundColorHover'))
      .add(text('textColor'))
      .add(text('textColorHover'))
  )

  return (
    <>
      <Component {...props.getValues()} Component={TagAllVariants} name='Tag' />
      <ComponentProps name='Tag' value={props} onChange={setProps} />
    </>
  )
}
